// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.is-comment-input[data-v-3bfa89b6] {\n  min-width: 20rem;\n}", ""]);
// Exports
module.exports = exports;
